export const reportDataIsDefined = (reportDataKeys, props) => reportDataKeys.reduce((defined, key) =>
  defined && !!props[key],
true
);

export const reportDataChanged = (reportDataKeys, prevProps, nextProps) => reportDataKeys.reduce((changed, key) =>
  changed || prevProps[key] !== nextProps[key],
false
);

